<template>
	<div class="council">
		<SubHeader title="Council" subtitle="理事会・事務局" />

		<div class="container">
			<div class="row justify-content-center">
				<div class="col-lg-6 mb-3">
					<h2 class="mb-3">理事会</h2>
					<table class="table table-striped">
						<thead>
							<tr>
								<th>役職</th>
								<th>氏名</th>
								<th>担当</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th scope="row">会長</th>
								<td>伊藤 輝夫</td>
								<td>&nbsp;</td>
							</tr>
							<tr>
								<th scope="row">副会長</th>
								<td>山本 貴信</td>
								<td>&nbsp;</td>
							</tr>
							<tr>
								<th scope="row">理事長</th>
								<td>角家 元二</td>
								<td>JDO評議員</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>吉岡 明日香</td>
								<td>総務・広報・会計監査・JDO副評議員</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>福山 誠</td>
								<td>会計・事務局</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>田島 孝康</td>
								<td>広報・競技</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>砂川 祥輝</td>
								<td>広報・競技</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>鈳 孝子</td>
								<td>広報・渉外</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>中村 真詞</td>
								<td>広報・リーグ運営</td>
							</tr>
							<tr>
								<th scope="row">理事</th>
								<td>坂東 和紘</td>
								<td>広報・リーグ運営</td>
							</tr>
						</tbody>
					</table>

					<h2 class="mt-4 mb-3">名誉会員</h2>
					<table class="table table-striped">
						<thead>
							<tr>
								<th>会員番号</th>
								<th>氏名</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th scope="row">1025</th>
								<td>渡辺 国雄</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="col-lg-6">
					<h2 class="mb-3">運営事務局</h2>
					<table class="table table-bordered">
						<tbody>
							<tr>
								<th class="table-active">住所</th>
								<td>〒558-0004 大阪市住吉区長居東4-2-7 長居中央ビル302</td>
							</tr>
							<tr>
								<th class="table-active">e-mail</th>
								<td>
									osakado04@gmail.com<br />（※以前のアドレス「odo@festa.ocn.ne.jp」は2026年度をもって廃止）
								</td>
							</tr>
						</tbody>
					</table>

					<h2 id="contact" class="mt-5 mb-3">お問い合わせ</h2>

					<h5>
						<i class="fa-solid fa-envelope mr-2"></i>メール・問い合わせフォーム
					</h5>
					<p>
						メールでの問い合わせはODO事務局のメールアドレス（<a href=""
							>osakado04@gmail.com</a
						>）よりお願いします。メールアドレスをお持ちでない場合、問い合わせフォームからご連絡いただく事も可能です。
					</p>
					<div class="row">
						<div class="col-12 text-right">
							<a
								class="btn btn-contact"
								href="https://forms.gle/SqnwnwYbm1tuQ2H86"
								target="_blank"
								><i class="far fa-envelope mr-2"></i> 問い合わせフォームへ</a
							>
						</div>
					</div>

					<h5><i class="fa-brands fa-line mr-2"></i>LINE公式アカウント</h5>
					<p>
						LINEでの問い合わせを希望される方は、ODO事務局のLINE公式アカウントよりご連絡ください。
					</p>
					<h6 class="font-weight-bold">■注意事項</h6>
					<ul class="caution--list">
						<li>
							LINE公式アカウントへの問い合わせ（トーク）を行う際は「友だち追加」が必要です
						</li>
						<li>
							LINE公式アカウントとのトーク内容が他のLINEユーザーに閲覧されることはありません（LINEグループではありません）
						</li>
						<li>
							以下のURLリンクやQRコードをシェアする事で、LINE公式アカウントを友だち追加できます。
						</li>
						<p class="text-center">
							<img
								src="images/line_gainfriends.png"
								alt="LINE公式アカウントを友だち追加"
								class="img-fluid"
							/>
						</p>
						<p>
							URLリンク：<a
								href="https://line.me/R/ti/p/@341lxtzp"
								target="_blank"
								>https://line.me/R/ti/p/@341lxtzp</a
							>
						</p>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import SubHeader from "@/components/common/SubHeader.vue";

export default {
	name: "council",
	components: {
		SubHeader,
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h2 {
	font-size: 1.5rem;
	font-weight: bold;
}
h5 {
	font-weight: bold;
	border-bottom: solid 1px #999;
	padding: 0.4rem;
	::v-deep i,
	::v-deep svg {
		font-size: 1.2rem;
		color: $primary-color;
	}
}
.container {
	padding: 4rem 1rem;
	text-align: left;
}
p {
	color: #333;
}
</style>
